<template>
  <div>
    <div class="ccui-navigation">
      <el-button
        size="mini"
        type="primary-icon-medium"
        icon="icon-ccui-return"
        @click="handleBack"
        >返回</el-button
      >
      <div class="ccui-navigation-divider" />
      <!-- 面包屑 -->
      <el-breadcrumb
        class="ccui-navigation-crumbs-container"
        separator-class="el-icon-arrow-right"
      >
        <el-breadcrumb-item
          :to="{ path: $store.getters.getBreadcrumb('level1').path }"
          >{{ $store.getters.getBreadcrumb("level1").name }}</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/pcconclease/item-list' }"
          >代码生成</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/pcconclease/item-list' }"
          >周转材租赁合同</el-breadcrumb-item
        >

        <el-breadcrumb-item>
          <span>编辑</span>
          <span class="ccui-curr-crumb ccui-ml-10">XXXX</span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="ccui-app-container-detail">
      <div class="ccui-app-container-detail-body">
        <pcConcLease :dataInfo="pcConcLease" ref="pcConcLease"></pcConcLease>
        <pcConcLeaseList
          :dataInfo="pcConcLeaseList"
          ref="pcConcLeaseList"
        ></pcConcLeaseList>
        <pcFinance :dataInfo="pcFinance" ref="pcFinance"></pcFinance>
        <concFiles :dataInfo="concFiles" ref="concFiles"></concFiles>
      </div>
    </div>
    <el-bottom-guide>
      <ul class="ccui-bottom-button">
        <li>
          <el-button type="bottom" icon="icon-ccui-return" @click="handleBack"
            >返回</el-button
          >
        </li>
        <div class="ccui-bottom-guide-divider" />
        <li>
          <el-button type="bottom" icon="icon-ccui-save" @click="submitHandle"
            >保存</el-button
          >
        </li>
        <li>
          <el-button type="bottom" icon="icon-ccui-cancel" @click="resetHandle"
            >取消</el-button
          >
        </li>
      </ul>
    </el-bottom-guide>
  </div>
</template>

<script>
import pcConcLease from "./pcConcLease";
import pcConcLeaseList from "./pcConcLeaseList";
import pcFinance from "./pcFinance";
import concFiles from "./concFiles";

import { postGetDetail, postEditPcConcLease } from "../../api/item-list";

export default {
  name: "editPcConcLease",
  components: {
    pcConcLease,
    pcConcLeaseList,
    pcFinance,
    concFiles
  },
  data() {
    return {
      focus: "pcConcLease",
      pcConcLease: {},
      pcConcLeaseList: [],
      pcFinance: {},
      concFiles: []
    };
  },
  created() {
    const arr = [this.$route.params.id];
    postGetDetail({ ids: arr }).then(data => {
      this.pcConcLease = data.data.data.pcConcLease;
      this.pcConcLeaseList = data.data.data.pcConcLeaseList;
      this.pcFinance = data.data.data.pcFinance;
      this.concFiles = data.data.data.concFiles;
    });
  },
  methods: {
    resetHandle() {
      const arr = [this.$route.params.id];
      postGetDetail({ ids: arr }).then(data => {
        this.pcConcLease = data.data.data.pcConcLease;
        this.pcConcLeaseList = data.data.data.pcConcLeaseList;
        this.pcFinance = data.data.data.pcFinance;
        this.concFiles = data.data.data.concFiles;
      });
    },
    submitHandle() {
      var pass;
      pass = true;
      this.$refs.pcFinance.$refs.form.validate(valid => {
        if (valid) {
          pass = true;
        } else {
          this.errorLocation(this.$refs.pcFinance);
          pass = false;
          return false;
        }
      });
      //最后检查主表
      this.$refs.pcConcLease.$refs.form.validate(valid => {
        if (valid && pass) {
          this.edit();
        } else {
          this.errorLocation(this.$refs.pcConcLease);
          pass = false;
          return false;
        }
      });
    },
    // 更新请求
    edit() {
      //收集表数据

      var pcConcLease = {
        id: this.$refs.pcConcLease.form.id,

        projectName: this.$refs.pcConcLease.form.projectName,

        isDeduction: this.$refs.pcConcLease.form.isDeduction,

        tContactId: this.$refs.pcConcLease.form.tContactId
      };
      var pcConcLeaseListList = [];
      if (this.$refs.pcConcLeaseList.tableData) {
        this.$refs.pcConcLeaseList.tableData.forEach(item => {
          pcConcLeaseListList.push({
            id: item.id,

            tPcConcLeaseId: item.tPcConcLeaseId,

            materialCode: item.materialCode,

            materialName: item.materialName,

            specifications: item.specifications,

            measuringUnit: item.measuringUnit,

            rentType: item.rentType,

            tenancyTerm: item.tenancyTerm,

            num: item.num,

            priceExcludeTax: item.priceExcludeTax,

            unitPriceExcludingTax: item.unitPriceExcludingTax,

            unitPriceIncludingTax: item.unitPriceIncludingTax,

            priceIncludeTax: item.priceIncludeTax,

            tax: item.tax,

            describe: item.describe,

            remark: item.remark,

            outstandingQuantity: item.outstandingQuantity,

            changeNum: item.changeNum,

            isAdjustTaxFlag: item.isAdjustTaxFlag
          });
        });
      }

      var pcFinance = {
        id: this.$refs.pcFinance.form.id,

        province: this.$refs.pcFinance.form.province,

        city: this.$refs.pcFinance.form.city,

        county: this.$refs.pcFinance.form.county,

        deliverPlace: this.$refs.pcFinance.form.deliverPlace,

        taxMethodCode: this.$refs.pcFinance.form.taxMethodCode,

        taxMethod: this.$refs.pcFinance.form.taxMethod,

        invoiceTypeCode: this.$refs.pcFinance.form.invoiceTypeCode,

        invoiceType: this.$refs.pcFinance.form.invoiceType,

        contractNum: this.$refs.pcFinance.form.contractNum,

        materialSource: this.$refs.pcFinance.form.materialSource,

        materialSourceCode: this.$refs.pcFinance.form.materialSourceCode,

        payTheCoefficient: this.$refs.pcFinance.form.payTheCoefficient,

        prepayment: this.$refs.pcFinance.form.prepayment,

        partyBId: this.$refs.pcFinance.form.partyBId,

        signPlace: this.$refs.pcFinance.form.signPlace,

        contractPerson: this.$refs.pcFinance.form.contractPerson,

        businessType: this.$refs.pcFinance.form.businessType,

        contractId: this.$refs.pcFinance.form.contractId
      };
      var concFilesList = [];
      if (this.$refs.concFiles.tableData) {
        this.$refs.concFiles.tableData.forEach(item => {
          concFilesList.push({
            id: item.id,

            businessId: item.businessId,

            businessType: item.businessType,

            fileInfoId: item.fileInfoId,

            fileName: item.fileName,

            fileSize: item.fileSize,

            fileType: item.fileType,

            fileUrl: item.fileUrl,

            fileDesc: item.fileDesc
          });
        });
      }

      const obj = {
        pcConcLease: pcConcLease,
        pcConcLeaseList: pcConcLeaseListList,
        pcFinance: pcFinance,
        concFiles: concFilesList,
        isShowLoading: true,
        loadingMessage: "保存中,请稍等..."
      };
      postEditPcConcLease(obj)
        .then(res => {
          let { code, message } = res.data;
          this.$message({
            message: message,
            type: code === "0" ? "success" : "error",
            // duration: code === "0" ? 3000 : '',
            showClose: true,
            ccuiCustom: true
          });
          if (code === "0") {
            this.submitFlag = true;
            // 清空附件缓存
            sessionStorage.removeItem("editAppendList");
            this.handleBack();
          }
        })
        .catch(e => {
          console.log(e);
        });
    },
    handleBack() {
      this.$router.push("/pcconclease/item-list");
    }
  }
};
</script>
